<template>
  <v-data-table
    item-key="id"
    :headers="headers"
    :loading="loading"
    :items="exams"
    :items-per-page="10"
    :disable-sort="$vuetify.breakpoint.smAndDown"
    :footer-props="{ 'items-per-page-text': 'Số kỳ thi mỗi trang' }"
    v-bind="this.$attrs"
  >
    <template v-slot:[`footer.page-text`]="items">
      Kỳ thi thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} kỳ thi
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <a :href="`/exams/${item.id}`" class="clickable-text">
        {{ item.name }}
      </a>
    </template>
    <template v-slot:[`item.grade`]="{ item }"> Khối {{ item.grade === 'secondary' ? '6' : '10' }} </template>
    <template v-slot:[`item.status`]="{ item }">
      {{ item | getStatus }}
    </template>
    <template v-slot:[`item.type`]="{ item }">
      {{ item | getType }}
    </template>
    <template v-slot:[`item.startDate`]="{ item }">
      {{ item | getDate }}
    </template>
  </v-data-table>
</template>

<script>
import { get } from 'lodash'
import moment from 'moment'
const originHeaders = [
  {
    text: 'Tên kỳ thi',
    value: 'name',
    align: 'left',
    sortable: false,
    show: true,
    width: '15%'
  },
  {
    text: 'Loại thi',
    value: 'type',
    align: 'left',
    sortable: false,
    show: true,
    width: '12%'
  },

  {
    text: 'Ngày thi',
    value: 'startDate',
    align: 'left',
    sortable: false,
    show: true,
    width: '15%'
  },
  {
    text: 'Địa điểm',
    value: 'location',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  },
  {
    text: 'Trạng thái',
    value: 'status',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  }
]

export default {
  props: {
    exams: Array
  },
  data() {
    return {
      loading: false,
      headers: originHeaders
    }
  },
  created() {
    this.loading = true
  },
  watch: {
    exams(newVal) {
      if (newVal) {
        this.loading = false
      }
    }
  },
  filters: {
    getDesc: item => {
      return get(item, 'note', 'Chưa có thông tin')
    },
    getStatus: item => {
      if (item.status === 'active') {
        return 'Đang hoạt động'
      } else if (item.status === 'inActive') {
        return 'Đã bị khóa'
      } else if (item.status === 'removed') {
        return 'Đã bị xóa'
      } else {
        return ''
      }
    },
    getType: item => {
      switch (item.type) {
        case 'midTerm':
          return 'Thi giữa kỳ'
        case 'final':
          return 'Thi cuối kỳ'
        case 'extra':
          return 'Thi thêm'
        default:
          return ''
      }
    },
    getDate: item => {
      if (item.startDate) return moment(item.startDate).format('DD/MM/YYYY')
      return 'Chưa có thông tin'
    }
  }
}
</script>
